"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var dangaoActApi = _interopRequireWildcard(require("@/api/dangaoActApi"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      ruleForm: {},
      loading: false,
      details: {},
      addresData: [],
      brandOption: [],
      shopLists: []
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    this.getCityList();
    this.searchBrand('');
    this.ruleForm = {};
    this.details = {};
    if (id && id != 0) {
      this.getSpecDetail(id);
    }
    ;
  },
  methods: {
    throttle: _throttle.default,
    handerSubmit: function handerSubmit(form) {
      var _this = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this.loading = true;
        var _ref = _this.ruleForm || {},
          _ref$storeIds = _ref.storeIds,
          storeIds = _ref$storeIds === void 0 ? [] : _ref$storeIds,
          cityCode = _ref.cityCode;
        dangaoActApi.updateEditcake(_objectSpread(_objectSpread({}, _this.ruleForm), {}, {
          storeIds: storeIds === null || storeIds === void 0 ? void 0 : storeIds.join(',')
          // cityCode: JSON.stringify(cityCode||[])
        })).then(function (data) {
          _this.$closeCompletedView();
          _this.$message.success('操作成功');
          _this.loading = false;
          _this.goReturn();
        }).catch(function () {
          _this.loading = false;
        });
      });
    },
    getSpecDetail: function getSpecDetail(id) {
      var _this2 = this;
      this.details = {};
      dangaoActApi.getDetailcake(id).then(function (res) {
        var _storeIds$split;
        _this2.details = res;
        var _ref2 = res || {},
          storeIds = _ref2.storeIds,
          cityCode = _ref2.cityCode;
        _this2.ruleForm = _objectSpread(_objectSpread({}, res), {}, {
          storeIds: (storeIds === null || storeIds === void 0 ? void 0 : (_storeIds$split = storeIds.split(',')) === null || _storeIds$split === void 0 ? void 0 : _storeIds$split.filter(function (v) {
            return v;
          })) || [],
          cityCode: cityCode
        });
        _this2.getShopLists();
      });
    },
    // 返回列表
    goReturn: function goReturn() {
      this.$router.push('/store/dangao/lists');
    },
    //上传图片
    modalPicTap: function modalPicTap(tit) {
      var _this3 = this;
      this.$modalUpload(function (img) {
        _this3.$set(_this3.ruleForm, 'albumPic', img[0].sattDir);
      }, tit, 'system');
    },
    removeImg: function removeImg() {
      this.$set(this.ruleForm, 'albumPic', '');
    },
    getCityList: function getCityList() {
      var _this$ruleForm,
        _this4 = this;
      this.addresData = [];
      dangaoActApi[((_this$ruleForm = this.ruleForm) === null || _this$ruleForm === void 0 ? void 0 : _this$ruleForm.source) == 2 ? 'getShopFslAddress' : 'getShopSelfAddress']().then(function (res) {
        _this4.addresData = res || [];
      });
    },
    searchBrand: function searchBrand() {
      var _this5 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      dangaoActApi.getAllDangaoBrand(keyword, 1).then(function (res) {
        _this5.brandOption = res && res.length && res.map(function (item) {
          var _ref3 = item || {},
            brandId = _ref3.brandId,
            brandName = _ref3.brandName,
            source = _ref3.source;
          return {
            id: brandId,
            brandName: brandName,
            brandStr: "".concat(brandName, "--ID").concat(brandId, "\u3010").concat(source, "\u3011")
          };
        }) || [];
      });
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this6 = this;
      this.throttle(function () {
        _this6.searchBrand(data);
      }, 300)();
    },
    getShopLists: function getShopLists() {
      var _this7 = this;
      var _ref4 = this.ruleForm || [],
        source = _ref4.source,
        brandId = _ref4.brandId,
        cityType = _ref4.cityType,
        cityCode = _ref4.cityCode;
      if (!(cityCode !== null && cityCode !== void 0 && cityCode.length)) return;
      this.shopLists = [];
      dangaoActApi.getAllShops({
        source: source,
        brandId: brandId,
        cityType: cityType,
        cityCodes: cityCode
      }).then(function (res) {
        _this7.shopLists = res || [];
      });
    }
  }
};